import { t } from '@transifex/native';

import type { EventBadgeVariant } from '@playbook/compositions/event-badge';

import { type Event, EventTypes } from 'pkg/api/models/event';
import {
	hasEventSeries,
	isFromRegistration,
} from 'pkg/api/models/event/guards';

const _context = 'eventTypes';

export function getTypeTranslation(eventType: EventTypes) {
	switch (eventType) {
		case EventTypes.Camp: {
			return t('Camp');
		}
		case EventTypes.Cup: {
			return t('Cup');
		}
		case EventTypes.Match: {
			return t('Match');
		}
		case EventTypes.Meeting: {
			return t('Meeting');
		}
		case EventTypes.Practice: {
			return t('Practice');
		}
		case EventTypes.Uncategorized: {
			return t('Other', { _context });
		}
	}
}

export function getEventBadgeVariant(type: EventTypes): EventBadgeVariant {
	switch (type) {
		case EventTypes.Match:
			return 'game';
		case EventTypes.Practice:
			return 'practice';
		case EventTypes.Meeting:
			return 'meeting';
		case EventTypes.Cup:
			return 'cup';
		case EventTypes.Camp:
			return 'camp';
		default:
			return 'other';
	}
}

/** An event in a series, or a registration booking session, takes its participant limit from its owner. */
export function capacityNoteOf(event: Event): string | null {
	if (hasEventSeries(event)) {
		return t(
			'Capacity is managed on the event series. Edit it on the series to change it.'
		);
	}

	if (isFromRegistration(event)) {
		return t(
			'Capacity is managed on the registration booking. Edit it in the registration config to change it.'
		);
	}

	return null;
}
